import { CustomError } from './ErrorMappers';
import ASYNC_STATUS from '../constants/async/statuses';
// import { errorAsyncCtechApi, errorAsyncCuotitasApi } from '../constants/errors/examples';

/**
 * Asynchronous call to avoid time out
 * @param {Promise} service it has to be (qs) => service(qs)
 * @param {Integer} time in miliseconds, default 3000
 * @returns response
 */
export const asyncService = async (service, time = 3000) => {
    const qs = {
        async: true// id de la proxima pregunta
    };
    // let response = errorAsyncCuotitasApi;
    // let response = errorAsyncCtechApi;
    let response = await service(qs);
    qs.async = response?.task?.id;// id de la proxima pregunta

    // We check if response is ready to use
    while (response?.task?.status?.id === ASYNC_STATUS.awaiting) {
        await sleep(time);
        response = await service(qs);
    }
    const responseSuccess = response?.ResultadoInterface?.Resultado === 1;
    // Check if it response has error?
    if (response?.task?.status?.id === ASYNC_STATUS.error || (!response?.task?.status?.id && !responseSuccess) || response?.task?.result?.code >= 400) {
        throw new CustomError(response);
    }

    return response?.task?.result || response;
};

/**
 * Simulate an asynchronous call
 * @param {Integer} ms time to wait in miliseconds
 * @returns void
 */
export function sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
